/*
  OFFER BUBBLE + PRINT PICKER  (Oct 2026 redesign, bundles update Oct 9,
  full collections Oct 15)

  Goal: move shoppers from 1-2 prints to a set of 3 or 5 unframed prints.
  The store's automatic discounts stay as they are (Buy 1 Get 1, Buy 2 Get 3):
    2 prints -> pay for 1, 3 prints -> pay for 2, 4-5 prints -> pay for 2.

  1. A small glowing notification at the bottom of every page (bottom left on
     desktop, bottom right on phones). It replaces the offer boxes that used to
     sit on product and collection pages:
       empty cart -> "2 offers available"          (opens the offers popup)
       1 print    -> "1 free poster to claim"      (opens the picker for the free one)
       2-4 prints -> "Add N more, pay for only 2"  (opens the picker to complete 5)
       5+         -> hidden

  2. The print picker popup. Opens from the bubble, from anything marked
     [data-op-suggest-trigger], and from the product page bundle chooser
     (window.opOffer.openPicker). In "set" mode it asks for a set number of
     prints, then closes and opens the cart.
     It only offers prints in the same size as the print being bought.
     A collection tab shows every print in that collection: the first ones
     load right away and the rest load as the shopper scrolls.
*/
(function () {
  if (window.__opOfferInit) return;
  window.__opOfferInit = true;

  var DISMISS_KEY = 'opOfferDismissedAt';
  var PAGE = 30; /* products fetched per request when scrolling a collection */
  var TABS = [
    { handle: '', label: 'For you' },
    { handle: 'golf', label: 'Golf' },
    { handle: 'soccer', label: 'Soccer' },
    { handle: 'racing', label: 'Racing' },
    { handle: 'cities', label: 'Cities' },
    { handle: 'national-parks', label: 'Parks' },
    { handle: 'cars', label: 'Cars' },
    { handle: 'tennis', label: 'Tennis' },
    { handle: 'iconic-venues', label: 'Venues' }
  ];

  var cart = null;
  var bubble = null;
  var picker = null;
  var cache = {};
  var activeTab = '';
  var loadToken = 0;
  var cur = null; /* the collection on screen: { handle, ctx, taken, items, page, done, loading } */
  var session = null; /* set mode: { need, added, size, productId, openCartOnClose, onClose } */

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  function onCartPage() {
    return /\/cart\/?$/.test(location.pathname);
  }

  /* ---------- styles ---------- */
  var css = '' +
    '.opb{position:fixed;right:16px;bottom:calc(16px + env(safe-area-inset-bottom,0px));z-index:40;display:flex;align-items:center;gap:10px;max-width:min(300px,calc(100vw - 32px));padding:10px 34px 10px 10px;border:1px solid rgba(0,0,0,.06);border-radius:18px;background:rgba(255,255,255,.86);-webkit-backdrop-filter:saturate(180%) blur(20px);backdrop-filter:saturate(180%) blur(20px);box-shadow:0 8px 28px rgba(0,0,0,.14);color:#1d1d1f;font-family:-apple-system,BlinkMacSystemFont,"SF Pro Text","Helvetica Neue",Helvetica,Arial,sans-serif;text-align:left;cursor:pointer;opacity:0;transform:translateY(12px);transition:opacity .3s ease,transform .3s ease;-webkit-tap-highlight-color:transparent}' +
    '.opb[hidden]{display:none}' +
    '.opb.is-in{opacity:1;transform:translateY(0)}' +
    '.opb--lift{bottom:calc(92px + env(safe-area-inset-bottom,0px))}' +
    '@media (min-width:700px){.opb{right:24px;bottom:24px}.opb--lift{bottom:24px}}' +
    '.opb__icon{flex:none;width:36px;height:36px;border-radius:10px;background:#1d1d1f;color:#fff;display:flex;align-items:center;justify-content:center}' +
    '.opb__icon svg{width:18px;height:18px}' +
    '.opb__text{display:flex;flex-direction:column;min-width:0}' +
    '.opb__title{font-size:14px;line-height:1.25;font-weight:600;letter-spacing:-.01em}' +
    '.opb__sub{font-size:12px;line-height:1.3;color:#6e6e73}' +
    '.opb__x{position:absolute;top:6px;right:6px;width:22px;height:22px;border:0;border-radius:50%;background:transparent;color:#86868b;font-size:16px;line-height:1;cursor:pointer;padding:0}' +
    '.opb__x:hover{background:rgba(0,0,0,.06)}' +
    '.opb:focus-visible,.opb__x:focus-visible{outline:2px solid #0071e3;outline-offset:2px}' +
    'body:has(cart-drawer[open]) .opb,body:has(.ofs.is-open) .opb,body:has(.opp.is-open) .opb,body:has(.ocd.is-open) .opb,body:has(.obf.is-open) .opb,body:has(.opo.is-open) .opb{opacity:0;pointer-events:none}' +
    '@property --opb-a{syntax:"<angle>";inherits:false;initial-value:0deg}' +
    '.opb{isolation:isolate;overflow:visible}' +
    '.opb::before,.opb::after{content:"";position:absolute;inset:-2px;border-radius:20px;z-index:-1;background:conic-gradient(from var(--opb-a),#ff5f6d,#ffc371,#7ee8a2,#4facfe,#a18cd1,#ff5f6d);animation:opbSpin 4s linear infinite}' +
    '.opb::before{filter:blur(10px);opacity:.55}' +
    '.opb::after{padding:2px;-webkit-mask:linear-gradient(#000 0 0) content-box,linear-gradient(#000 0 0);-webkit-mask-composite:xor;mask:linear-gradient(#000 0 0) content-box exclude,linear-gradient(#000 0 0)}' +
    '@keyframes opbSpin{to{--opb-a:360deg}}' +
    '.opb__icon{background:linear-gradient(135deg,#ff5f6d,#a18cd1 55%,#4facfe)}' +

    '.opo{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:flex-end;justify-content:center;font-family:-apple-system,BlinkMacSystemFont,"SF Pro Text","Helvetica Neue",Helvetica,Arial,sans-serif}' +
    '.opo[hidden]{display:none}' +
    '.opo__backdrop{position:absolute;inset:0;background:rgba(0,0,0,.3);opacity:0;transition:opacity .24s ease}' +
    '.opo.is-open .opo__backdrop{opacity:1}' +
    '.opo__panel{position:relative;box-sizing:border-box;width:100%;max-width:420px;background:#fff;color:#1d1d1f;border-radius:22px 22px 0 0;padding:22px 20px calc(20px + env(safe-area-inset-bottom,0px));transform:translateY(100%);transition:transform .3s cubic-bezier(.4,0,1,1)}' +
    '.opo.is-open .opo__panel{transform:none;transition:transform .5s cubic-bezier(.22,1,.36,1)}' +
    '.opo__x{position:absolute;top:12px;right:12px;width:32px;height:32px;border:0;border-radius:50%;background:#f5f5f7;color:#6e6e73;font-size:20px;line-height:1;cursor:pointer}' +
    '.opo__title{margin:0 40px 4px 0;font-size:22px;line-height:1.15;font-weight:600;letter-spacing:-.022em;text-transform:none}' +
    '.opo__sub{margin:0 0 16px;font-size:14px;line-height:1.4;color:#6e6e73}' +
    '.opo__row{display:flex;gap:12px;align-items:flex-start;padding:14px 0;border-top:1px solid #e8e8ed}' +
    '.opo__num{flex:none;width:40px;height:40px;border-radius:12px;background:#f5f5f7;display:flex;align-items:center;justify-content:center;font-size:13px;font-weight:700;letter-spacing:-.01em}' +
    '.opo__row b{display:block;font-size:16px;font-weight:600;letter-spacing:-.012em}' +
    '.opo__row span{display:block;margin-top:2px;font-size:13px;line-height:1.4;color:#6e6e73}' +
    '.opo__go{display:block;width:100%;margin-top:8px;border:0;border-radius:980px;background:#1d1d1f;color:#fff;padding:15px 20px;font:inherit;font-size:16px;font-weight:500;cursor:pointer}' +
    '.opo__x:focus-visible,.opo__go:focus-visible{outline:2px solid #0071e3;outline-offset:2px}' +
    '@media (min-width:700px){.opo{align-items:flex-end;justify-content:flex-start;padding:24px}.opo__panel{border-radius:22px;box-shadow:0 24px 60px rgba(0,0,0,.22);transform:translateY(16px) scale(.97);opacity:0;transform-origin:0 100%;transition:transform .2s ease,opacity .18s ease;margin-bottom:72px}.opo.is-open .opo__panel{transform:none;opacity:1;transition:transform .45s cubic-bezier(.34,1.32,.64,1),opacity .25s ease}}' +

    '.opp{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:flex-end;justify-content:center;font-family:-apple-system,BlinkMacSystemFont,"SF Pro Text","Helvetica Neue",Helvetica,Arial,sans-serif}' +
    '.opp[hidden]{display:none}' +
    '.opp__backdrop{position:absolute;inset:0;background:rgba(0,0,0,.42);opacity:0;transition:opacity .28s ease}' +
    '.opp__panel{position:relative;box-sizing:border-box;width:100%;max-width:640px;height:88vh;height:88dvh;max-height:760px;display:flex;flex-direction:column;background:#fff;color:#1d1d1f;border-radius:22px 22px 0 0;transform:translateY(100%);transition:transform .34s cubic-bezier(.32,.72,0,1)}' +
    '.opp.is-open .opp__backdrop{opacity:1}' +
    '.opp.is-open .opp__panel{transform:translateY(0)}' +
    '.opp__head{flex:none;padding:22px 52px 12px 20px;text-align:left}' +
    '.opp__title{margin:0;font-size:22px;line-height:1.15;font-weight:600;letter-spacing:-.022em;text-transform:none}' +
    '.opp__sub{margin:6px 0 0;font-size:14px;line-height:1.4;color:#6e6e73}' +
    '.opp__steps{display:flex;gap:6px;margin-top:12px}' +
    '.opp__steps[hidden]{display:none}' +
    '.opp__step{width:28px;height:4px;border-radius:2px;background:#e8e8ed;transition:background .25s ease}' +
    '.opp__step.is-done{background:#0071e3}' +
    '.opp__x{position:absolute;top:14px;right:14px;width:32px;height:32px;border:0;border-radius:50%;background:#f5f5f7;color:#6e6e73;font-size:20px;line-height:1;cursor:pointer}' +
    '.opp__tabs{flex:none;display:flex;gap:6px;overflow-x:auto;padding:4px 20px 12px;scrollbar-width:none;-webkit-overflow-scrolling:touch}' +
    '.opp__tabs::-webkit-scrollbar{display:none}' +
    '.opp__tab{flex:none;border:0;border-radius:980px;background:#f5f5f7;color:#1d1d1f;padding:9px 15px;font:inherit;font-size:14px;line-height:1.2;white-space:nowrap;cursor:pointer;transition:background .15s ease,color .15s ease}' +
    '.opp__tab[aria-selected="true"]{background:#1d1d1f;color:#fff}' +
    '.opp__body{flex:1;min-height:0;overflow-y:auto;overscroll-behavior:contain;padding:4px 20px calc(20px + env(safe-area-inset-bottom,0px))}' +
    '.opp__grid{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:16px 12px}' +
    '.opp__card{display:flex;flex-direction:column;border:0;padding:0;background:none;font:inherit;color:inherit;text-align:left;cursor:pointer}' +
    '.opp__img{aspect-ratio:1/1;background:#f5f5f7;border-radius:16px;overflow:hidden}' +
    '.opp__img img{width:100%;height:100%;object-fit:cover;display:block}' +
    '.opp__name{margin-top:8px;font-size:14px;line-height:1.3;font-weight:500;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}' +
    '.opp__cta{margin-top:2px;font-size:14px;color:#0071e3}' +
    '.opp__card:disabled{cursor:default}' +
    '.opp__card.is-busy{opacity:.5;cursor:wait}' +
    '.opp__card.is-added .opp__cta{color:#1d1d1f;font-weight:600}' +
    '.opp__card:focus-visible,.opp__x:focus-visible,.opp__tab:focus-visible,.opp__done:focus-visible{outline:2px solid #0071e3;outline-offset:2px}' +
    '.opp__msg{padding:36px 0 12px;font-size:15px;color:#6e6e73;text-align:center}' +
    '.opp__more{min-height:20px;padding:20px 0 6px;font-size:13px;color:#86868b;text-align:center}' +
    '.opp__foot{flex:none;padding:12px 20px calc(14px + env(safe-area-inset-bottom,0px));border-top:1px solid #e8e8ed}' +
    '.opp__foot[hidden]{display:none}' +
    '.opp__done{display:block;width:100%;border:0;border-radius:980px;background:#1d1d1f;color:#fff;padding:15px 20px;font:inherit;font-size:17px;font-weight:500;letter-spacing:-.01em;cursor:pointer}' +
    '@media (min-width:700px){.opp{align-items:center;padding:24px}.opp__panel{height:auto;min-height:420px;max-height:min(86vh,760px);border-radius:22px;box-shadow:0 24px 60px rgba(0,0,0,.22);transform:translateY(16px) scale(.98);opacity:0;transition:transform .28s ease,opacity .28s ease}.opp.is-open .opp__panel{opacity:1;transform:translateY(0) scale(1)}.opp__grid{grid-template-columns:repeat(3,minmax(0,1fr));gap:20px 16px}.opp__head{padding:24px 56px 14px 24px}.opp__tabs{padding:4px 24px 14px;flex-wrap:wrap;overflow:visible}.opp__body{padding:4px 24px 24px}.opp__foot{padding:14px 24px 18px}}' +
    '@media (prefers-reduced-motion:reduce){.opb,.opp__backdrop,.opp__panel,.opp__tab,.opp__step,.opo__backdrop,.opo__panel{transition:none}.opb::before,.opb::after{animation:none}}';

  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  /* ---------- cart state ---------- */
  function counted(c) {
    if (!c || !c.items) return [];
    return c.items.filter(function (it) {
      return !/framing service/i.test(it.product_title || '') && it.handle !== 'custom-poster';
    });
  }

  function countOf(c) {
    return counted(c).reduce(function (n, it) { return n + it.quantity; }, 0);
  }

  /* What the shopper can do right now. Bubble is null when hidden. */
  function offer() {
    var n = countOf(cart);
    if (n === 0) {
      return { n: n, bubble: { title: '2 offers available', sub: 'Buy 1, get 1 free. Tap to see' },
        pTitle: 'Build your set', pSub: 'Pick 3 prints and pay for 2, or pick 5 and still pay for 2.' };
    }
    if (n === 1) {
      return { n: n, bubble: { title: '1 free poster to claim', sub: 'Buy 1, get 1 free. Tap to pick' },
        pTitle: 'Pick your free poster', pSub: 'Buy 1, get 1 free. It comes off automatically at checkout.' };
    }
    if (n < 5) {
      var more = 5 - n;
      return { n: n, bubble: { title: 'Add ' + more + ' more, pay for only 2', sub: 'Buy 2, get 3 free' },
        pTitle: 'Add ' + more + ' more ' + (more === 1 ? 'print' : 'prints'), pSub: 'Five prints for the price of two. The discount is applied in your cart.' };
    }
    return { n: n, bubble: null,
      pTitle: 'Add more prints', pSub: 'Buy 2, get 3 free is already applied to your cart.' };
  }

  function fetchCart() {
    return fetch(root() + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { cart = c; renderBubble(); return c; })
      .catch(function () { return null; });
  }

  /* ---------- bubble ---------- */
  function dismissedAt() {
    try { return sessionStorage.getItem(DISMISS_KEY); } catch (e) { return null; }
  }

  /* One print in the cart: pick the free one. Two to four: complete the five. */
  function openFromOffer() {
    var n = countOf(cart);
    if (n === 0) { openOffers(); return; }
    if (n === 1) openPicker({ need: 1 });
    else if (n > 1 && n < 5) openPicker({ need: 5 - n });
    else openPicker();
  }

  function buildBubble() {
    if (bubble) return bubble;
    bubble = document.createElement('div');
    bubble.className = 'opb';
    bubble.hidden = true;
    bubble.setAttribute('role', 'button');
    bubble.setAttribute('tabindex', '0');
    bubble.innerHTML =
      '<span class="opb__icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13"/><path d="M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7"/><path d="M7.5 8a2.5 2.5 0 0 1 0-5C10 3 12 8 12 8s2-5 4.5-5a2.5 2.5 0 0 1 0 5"/></svg></span>' +
      '<span class="opb__text"><span class="opb__title"></span><span class="opb__sub"></span></span>' +
      '<button type="button" class="opb__x" aria-label="Hide this reminder">&times;</button>';
    document.body.appendChild(bubble);

    bubble.addEventListener('click', function (e) {
      if (e.target.closest('.opb__x')) {
        e.stopPropagation();
        try { sessionStorage.setItem(DISMISS_KEY, String(countOf(cart))); } catch (err) {}
        renderBubble();
        return;
      }
      openFromOffer();
    });
    bubble.addEventListener('keydown', function (e) {
      if (e.target !== bubble) return;
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openFromOffer(); }
    });
    return bubble;
  }

  function renderBubble() {
    var o = offer();
    if (!o.bubble || dismissedAt() === String(o.n)) {
      if (bubble) { bubble.classList.remove('is-in'); bubble.hidden = true; }
      return;
    }
    buildBubble();
    bubble.querySelector('.opb__title').textContent = o.bubble.title;
    bubble.querySelector('.opb__sub').textContent = o.bubble.sub;
    bubble.setAttribute('aria-label', o.bubble.title + '. ' + o.bubble.sub);
    bubble.classList.toggle('opb--lift', !!document.querySelector('product-quick-add'));
    if (bubble.hidden) {
      bubble.hidden = false;
      void bubble.offsetHeight;
    }
    bubble.classList.add('is-in');
  }

  /* ---------- offers popup (empty cart) ---------- */
  var offersEl = null;
  function openOffers() {
    if (!offersEl) {
      offersEl = document.createElement('div');
      offersEl.className = 'opo';
      offersEl.hidden = true;
      offersEl.innerHTML =
        '<div class="opo__backdrop" data-opo-close></div>' +
        '<div class="opo__panel" role="dialog" aria-modal="true" aria-labelledby="opo-title">' +
          '<button type="button" class="opo__x" data-opo-close aria-label="Close">&times;</button>' +
          '<h2 class="opo__title" id="opo-title">Your offers</h2>' +
          '<p class="opo__sub">Both come off automatically in your cart. Mix any designs.</p>' +
          '<div class="opo__row"><span class="opo__num">1+1</span><div><b>Buy 1, get 1 free</b><span>Add any two prints. The second one is free.</span></div></div>' +
          '<div class="opo__row"><span class="opo__num">2+3</span><div><b>Buy 2, get 3 free</b><span>Five prints for the price of two.</span></div></div>' +
          '<button type="button" class="opo__go" data-opo-close>Start picking prints</button>' +
        '</div>';
      document.body.appendChild(offersEl);
      ['pointerdown', 'mousedown', 'touchstart'].forEach(function (type) {
        offersEl.addEventListener(type, function (e) { e.stopPropagation(); }, { passive: true });
      });
      offersEl.addEventListener('click', function (e) {
        e.stopPropagation();
        if (e.target.closest('[data-opo-close]')) closeOffers();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && offersEl && !offersEl.hidden) closeOffers();
      }, true);
    }
    offersEl.hidden = false;
    void offersEl.offsetHeight;
    offersEl.classList.add('is-open');
    var go = offersEl.querySelector('.opo__go');
    setTimeout(function () { try { go.focus({ preventScroll: true }); } catch (e) {} }, 60);
  }
  function closeOffers() {
    if (!offersEl || offersEl.hidden) return;
    offersEl.classList.remove('is-open');
    setTimeout(function () { if (!offersEl.classList.contains('is-open')) offersEl.hidden = true; }, 320);
  }

  /* ---------- picker: data ---------- */
  function imageOf(product, variant) {
    var src = null;
    if (variant && variant.featured_image) src = variant.featured_image.src || variant.featured_image;
    if (!src && product.featured_image) src = product.featured_image.src || product.featured_image;
    if (!src && product.image) src = product.image.src || product.image;
    if (!src && product.images && product.images.length) src = product.images[0].src || product.images[0];
    if (!src || typeof src !== 'string') return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=480';
  }

  /* Show each print the way it looks best: in a black frame (same size, else 12x18,
     else any black frame). Falls back to the poster photo. Only the photo changes;
     the print added is still the poster-only variant. */
  function framedLook(p, size) {
    var best = null, rank = 9;
    (p.variants || []).forEach(function (v) {
      var opts = (v.option2 || '') + ' ' + (v.option3 || '');
      if (!/black/i.test(opts) || !/frame/i.test(opts) || /hanger/i.test(opts)) return;
      if (!v.featured_image) return;
      var r = (size && v.option1 === size) ? 0 : (/12\s*x\s*18/i.test(v.option1 || '') ? 1 : 2);
      if (r < rank) { rank = r; best = v; }
    });
    return best;
  }

  /* The rules for this moment: prints in the same size as the one being bought. */
  function context() {
    var anchor = counted(cart)[0] || null;
    var size = (session && session.size) || (anchor ? (anchor.variant_options || [])[0] : null);
    return { anchor: anchor, size: size };
  }

  /* The unframed print: "Poster Only" on most products, "No Frame" on a few. */
  function isPoster(v) {
    return !v.option2 || v.option2 === 'Poster Only' || v.option2 === 'No Frame';
  }

  function qualify(products, ctx, taken, out, max) {
    (products || []).forEach(function (p) {
      if (out.length >= max) return;
      if (!p || !p.variants || !p.variants.length) return;
      if (taken.ids[p.id] || taken.titles[p.title]) return;
      if (p.handle === 'custom-poster' || /gift card|framing service|towel|calendar|\(test\)/i.test(p.title || '')) return;
      var match = null;
      p.variants.forEach(function (v) {
        if (match || v.available === false) return;
        if (ctx.size && v.option1 !== ctx.size) return;
        if (!isPoster(v)) return;
        match = v;
      });
      if (!match) return;
      taken.ids[p.id] = true;
      taken.titles[p.title] = true;
      out.push({ id: match.id, title: p.title, image: imageOf(p, framedLook(p, ctx.size) || match) });
    });
    return out;
  }

  function getJson(url) {
    return fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .catch(function () { return { products: [] }; });
  }

  function cacheKey(handle) {
    var ctx = context();
    var sessionPid = session && session.productId ? session.productId : '';
    return (handle || 'foryou') + '|' + (ctx.size || 'any') + '|' + (ctx.anchor ? ctx.anchor.variant_id : 'none') + '|' + sessionPid;
  }

  /* Prints already in the cart (and the one being bought) are left out. */
  function takenNow() {
    var taken = { ids: {}, titles: {} };
    counted(cart).forEach(function (it) { taken.ids[it.product_id] = true; taken.titles[it.product_title] = true; });
    if (session && session.productId) taken.ids[session.productId] = true;
    return taken;
  }

  /* "For you": related to what is being bought, topped up from the whole catalogue */
  function loadForYou() {
    var key = cacheKey('');
    if (cache[key]) return Promise.resolve(cache[key]);
    var ctx = context();
    var taken = takenNow();
    var out = [];
    var ids = [];
    if (session && session.productId) ids.push(session.productId);
    counted(cart).forEach(function (it) { if (ids.indexOf(it.product_id) === -1) ids.push(it.product_id); });
    var calls = ids.slice(0, 3).map(function (pid) {
      return getJson(root() + 'recommendations/products.json?product_id=' + pid + '&limit=10&intent=related');
    });
    return Promise.all(calls)
      .then(function (results) {
        results.forEach(function (d) { qualify(d.products, ctx, taken, out, 12); });
        if (out.length >= 6) return null;
        return getJson(root() + 'collections/all/products.json?limit=60')
          .then(function (d) { qualify(d.products, ctx, taken, out, 12); });
      })
      .then(function () { cache[key] = out; return out; });
  }

  /* A collection tab: every print in it, fetched one page at a time. */
  function collState(handle) {
    var key = cacheKey(handle);
    if (!cache[key]) {
      cache[key] = { handle: handle, ctx: context(), taken: takenNow(), items: [], page: 0, done: false, loading: null };
    }
    return cache[key];
  }

  /* Fetches the next page. Resolves with the prints it added. */
  function more(st) {
    if (st.done) return Promise.resolve([]);
    if (st.loading) return st.loading;
    st.page++;
    var start = st.items.length;
    st.loading = getJson(root() + 'collections/' + st.handle + '/products.json?limit=' + PAGE + '&page=' + st.page)
      .then(function (d) {
        var list = d.products || [];
        if (list.length < PAGE) st.done = true;
        qualify(list, st.ctx, st.taken, st.items, Infinity);
        st.loading = null;
        return st.items.slice(start);
      });
    return st.loading;
  }

  /* ---------- picker: interface ---------- */
  function escapeHtml(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function cardHtml(c) {
    return '<button type="button" class="opp__card" data-opp-add="' + c.id + '">' +
      '<span class="opp__img">' + (c.image ? '<img loading="lazy" alt="" src="' + escapeHtml(c.image) + '">' : '') + '</span>' +
      '<span class="opp__name">' + escapeHtml(c.title) + '</span>' +
      '<span class="opp__cta">Add</span></button>';
  }

  function buildPicker() {
    if (picker) return picker;
    picker = document.createElement('div');
    picker.className = 'opp';
    picker.hidden = true;
    picker.innerHTML =
      '<div class="opp__backdrop" data-opp-close></div>' +
      '<div class="opp__panel" role="dialog" aria-modal="true" aria-labelledby="opp-title">' +
        '<button type="button" class="opp__x" data-opp-close aria-label="Close">&times;</button>' +
        '<div class="opp__head"><h2 class="opp__title" id="opp-title"></h2><p class="opp__sub"></p><div class="opp__steps" hidden></div></div>' +
        '<div class="opp__tabs" role="tablist" aria-label="Collections">' +
          TABS.map(function (t) {
            return '<button type="button" class="opp__tab" role="tab" data-opp-tab="' + t.handle + '" aria-selected="false">' + t.label + '</button>';
          }).join('') +
        '</div>' +
        '<div class="opp__body"></div>' +
        '<div class="opp__foot" hidden><button type="button" class="opp__done" data-opp-done>Done, show my cart</button></div>' +
      '</div>';
    document.body.appendChild(picker);

    ['pointerdown', 'mousedown', 'touchstart'].forEach(function (type) {
      picker.addEventListener(type, function (e) { e.stopPropagation(); }, { passive: true });
    });
    picker.addEventListener('click', function (e) {
      e.stopPropagation();
      if (e.target.closest('[data-opp-done]')) { closePicker(true); return; }
      if (e.target.closest('[data-opp-close]')) { closePicker(picker.getAttribute('data-added') === '1'); return; }
      var tab = e.target.closest('[data-opp-tab]');
      if (tab) { showTab(tab.getAttribute('data-opp-tab')); return; }
      var card = e.target.closest('[data-opp-add]');
      if (card && !card.disabled) addPrint(card);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && picker && !picker.hidden) { e.stopPropagation(); closePicker(picker.getAttribute('data-added') === '1'); }
    }, true);

    /* Load the next prints as the shopper nears the bottom of the list */
    var ticking = false;
    picker.querySelector('.opp__body').addEventListener('scroll', function () {
      if (!cur || ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { ticking = false; if (cur) fill(cur, loadToken); });
    }, { passive: true });
    return picker;
  }

  function setHead() {
    var ctx = context();
    var title, sub;
    var steps = picker.querySelector('.opp__steps');
    if (session) {
      var left = session.need - session.added;
      var have = Math.max(countOf(cart) - session.added, 1);
      var setOf = have + session.need;
      if (setOf === 2) {
        title = left > 0 ? 'Pick your free poster' : 'Your free poster is in';
        sub = 'Buy 1, get 1 free. It comes off automatically at checkout.';
      } else if (setOf === 5) {
        title = left > 0 ? 'Pick ' + left + ' more ' + (left === 1 ? 'print' : 'prints') : 'All 5 are in';
        sub = 'Buy 2, get 3 free: five prints for the price of two.';
      } else {
        title = left > 0 ? 'Pick ' + left + ' more ' + (left === 1 ? 'print' : 'prints') : 'Your set is complete';
        sub = 'Your set of ' + setOf + ': you pay for 2, the cheapest ' + (setOf - 2 === 1 ? 'print is' : (setOf - 2) + ' prints are') + ' free.';
      }
      var html = '';
      for (var i = 0; i < setOf; i++) {
        html += '<span class="opp__step' + (i < have + session.added ? ' is-done' : '') + '"></span>';
      }
      steps.innerHTML = html;
      steps.hidden = false;
    } else {
      var o = offer();
      title = o.pTitle;
      sub = o.pSub;
      steps.hidden = true;
    }
    picker.querySelector('.opp__title').textContent = title;
    picker.querySelector('.opp__sub').textContent = sub + (ctx.size ? ' Showing prints in ' + ctx.size + '.' : '');
  }

  /* Keeps loading pages while the end of the list is on screen or close to it. */
  function fill(st, token) {
    if (token !== loadToken || st !== cur || st.loading) return;
    var body = picker.querySelector('.opp__body');
    var grid = body.querySelector('.opp__grid');
    var moreEl = body.querySelector('[data-opp-more]');
    if (!grid || !moreEl) return;
    if (st.done) {
      if (!st.items.length) {
        body.innerHTML = '<div class="opp__msg">No prints in this size here. Try another collection.</div>';
      } else {
        moreEl.textContent = st.items.length === 1 ? '1 print in this collection' : 'All ' + st.items.length + ' prints in this collection';
      }
      return;
    }
    var gap = moreEl.getBoundingClientRect().top - body.getBoundingClientRect().bottom;
    if (st.items.length && gap > 900) return;
    moreEl.textContent = st.items.length ? 'Loading more prints' : '';
    more(st).then(function (added) {
      if (token !== loadToken || st !== cur) return;
      if (added.length) grid.insertAdjacentHTML('beforeend', added.map(cardHtml).join(''));
      fill(st, token);
    });
  }

  function showTab(handle) {
    activeTab = handle || '';
    picker.querySelectorAll('[data-opp-tab]').forEach(function (b) {
      b.setAttribute('aria-selected', b.getAttribute('data-opp-tab') === activeTab ? 'true' : 'false');
    });
    var body = picker.querySelector('.opp__body');
    var token = ++loadToken;
    cur = null;
    body.scrollTop = 0;

    if (activeTab) {
      var st = collState(activeTab);
      cur = st;
      body.innerHTML = '<div class="opp__grid">' + st.items.map(cardHtml).join('') + '</div>' +
        '<div class="opp__more" data-opp-more>' + (st.items.length ? '' : 'Loading prints') + '</div>';
      fill(st, token);
      return;
    }

    body.innerHTML = '<div class="opp__msg">Loading prints</div>';
    loadForYou().then(function (list) {
      if (token !== loadToken) return;
      if (!list.length) {
        body.innerHTML = '<div class="opp__msg">No prints in this size here. Try another collection.</div>';
        return;
      }
      body.innerHTML = '<div class="opp__grid">' + list.map(cardHtml).join('') + '</div>';
      body.scrollTop = 0;
    });
  }

  /* opts (all optional): need = prints to pick, size, productId, tab,
     openCartOnClose = open the cart however the picker is closed,
     onClose = called when the picker closes. */
  function openPicker(opts) {
    opts = opts || {};
    if (!cart && !opts.size) { fetchCart().then(function (c) { if (c) openPicker(opts); }); return; }
    buildPicker();
    session = opts.need ? {
      need: opts.need, added: 0, size: opts.size || null, productId: opts.productId || null,
      openCartOnClose: !!opts.openCartOnClose, onClose: opts.onClose || null
    } : null;
    cache = {};
    picker.setAttribute('data-added', '0');
    picker.querySelector('.opp__foot').hidden = true;
    setHead();
    picker.hidden = false;
    void picker.offsetHeight;
    picker.classList.add('is-open');
    showTab(opts.tab || '');
  }

  function openCart() {
    if (onCartPage()) { location.reload(); return; }
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    try {
      if (typeof drawer.show === 'function') drawer.show();
      else drawer.setAttribute('open', '');
    } catch (e) {}
  }

  function closePicker(thenCart) {
    if (!picker || picker.hidden) return;
    var s = session;
    session = null;
    cur = null;
    loadToken++;
    if (s && s.openCartOnClose) thenCart = true;
    picker.classList.remove('is-open');
    if (s && s.onClose) { try { s.onClose(); } catch (e) {} }
    setTimeout(function () {
      if (!picker.classList.contains('is-open')) picker.hidden = true;
      if (thenCart) openCart();
    }, 340);
  }

  function addPrint(card) {
    var cards = picker.querySelectorAll('[data-opp-add]');
    cards.forEach(function (b) { if (!b.classList.contains('is-added')) { b.disabled = true; b.classList.add('is-busy'); } });
    var cta = card.querySelector('.opp__cta');
    if (cta) cta.textContent = 'Adding';

    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [ { id: parseInt(card.getAttribute('data-opp-add'), 10), quantity: 1 } ] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return fetch(root() + 'cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        cart = c;
        cache = {};
        picker.setAttribute('data-added', '1');
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { cart: c } }));
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        renderBubble();

        /* Set complete: go straight to the cart. */
        if (session) {
          session.added++;
          if (session.added >= session.need) { setHead(); closePicker(true); return; }
        } else if (countOf(cart) >= 5) { closePicker(true); return; }

        /* Still building: stay open so they can add more. */
        card.classList.remove('is-busy');
        card.classList.add('is-added');
        card.disabled = true;
        if (cta) cta.textContent = 'Added';
        picker.querySelectorAll('[data-opp-add]').forEach(function (b) {
          if (b.classList.contains('is-added')) return;
          b.disabled = false; b.classList.remove('is-busy');
        });
        setHead();
        picker.querySelector('.opp__foot').hidden = false;
      })
      .catch(function () {
        picker.querySelectorAll('[data-opp-add]').forEach(function (b) {
          if (b.classList.contains('is-added')) return;
          b.disabled = false; b.classList.remove('is-busy');
        });
        if (cta) cta.textContent = 'Try again';
      });
  }

  /* ---------- wiring ---------- */
  window.opOffer = {
    openPicker: openPicker,
    count: function () { return countOf(cart); }
  };

  /* Every "browse prints" link and button in the cart opens this picker. */
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-op-suggest-trigger]');
    if (!t) return;
    e.preventDefault();
    openFromOffer();
  });

  document.documentElement.addEventListener('cart:change', function (e) {
    if (e.detail && e.detail.cart && e.detail.cart.items) {
      cart = e.detail.cart;
      cache = {};
      renderBubble();
    } else {
      fetchCart();
    }
  });
  document.addEventListener('variant:add', function () { setTimeout(fetchCart, 400); });
  document.addEventListener('cart:refresh', function () { setTimeout(fetchCart, 700); });

  function start() { setTimeout(fetchCart, 1200); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
